import React from 'react'

export default class NetworkProvider extends React.Component {
  componentDidMount() {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  }

  handleBeforeUnload = event => {
    if (this.props.sendingData) {
      event.returnValue = 'You have some unsaved changes. Do you want to continue'
    }
  }

  render() {
    return null
  }
}
